"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ResponsiveMenu = _interopRequireDefault(require("../ResponsiveMenu/ResponsiveMenu"));

var _Config = require("base-shell/lib/providers/Config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = function Menu(props) {
  var _useConfig = (0, _Config.useConfig)(),
      appConfig = _useConfig.appConfig;

  var _ref = appConfig || {},
      menu = _ref.menu;

  var _ref2 = menu || {},
      MenuHeader = _ref2.MenuHeader,
      MenuContent = _ref2.MenuContent;

  return /*#__PURE__*/_react.default.createElement(_ResponsiveMenu.default, null, MenuHeader && /*#__PURE__*/_react.default.createElement(MenuHeader, null), MenuContent && /*#__PURE__*/_react.default.createElement(MenuContent, null));
};

var _default = Menu;
exports.default = _default;
module.exports = exports.default;